<template>
  <div class="no-data" :style="{ height: `${$props.height}px` }">
    <template v-if="!$props.error">
      <img v-if="!$props.noEmptyImg" class="img" src="@/assets/images/common/no-data.svg" />
      <slot name="no-data-img"></slot>
      <div>{{ text }}</div>
    </template>
    <template v-else>
      <div class="error">
        {{ $t('common.errorHint') }}
        <span class="link" @click="$emit('reload')">{{ $t('common.reload') }}</span>
      </div>
    </template>
  </div>
</template>

<script setup>
import { computed, defineEmits, defineProps } from 'vue'
import { useI18n } from 'vue-i18n'

const $emit = defineEmits(['reload'])
const $props = defineProps({
  text: {
    type: String || Function,
    // eslint-disable-next-line vue/valid-define-props
    default: '',
  },
  height: {
    type: Number,
    default: 200,
  },
  noEmptyImg: {
    type: Boolean,
    default: false,
  },
  error: {
    type: Boolean,
    default: false,
  },
})
const { t } = useI18n()
const text = computed({
  get() {
    return $props.text || t('common.noData')
  },
})
</script>

<style lang="scss" scoped>
.no-data {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  color: var(--black-color-3d);

  .img {
    margin-bottom: 16px;
  }

  .error {
    .link {
      cursor: pointer;
      color: var(--primary-color);
    }
  }
}
</style>
